import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/banner/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/banner/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/banner/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/banner/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/banner/delete',
        method: 'post',
        data
    })
}

